import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { JsonViewer } from '@dataxpdtn/mui-json-viewer';
import config from '@iotv/config';
import { Stack } from '@mui/material';
import { AlertErrors } from '../../ErrorHandling/ErrorBoundaryFallback';
import { AppInfo } from '../utils/AppInfo';
import { AppVersion } from '../utils/AppVersion';
const appCode = config.app.appCode.substring(0, 4);
const debug = process.env.REACT_APP_DEBUG && false;
export const ProjectConfig = (props) => {
    return (_jsxs(Stack, { gap: 1, children: [_jsx(AppInfo, { show: true }), _jsx(AppVersion, {}), _jsx(Stack, { children: _jsx(AlertErrors, { children: _jsx(JsonViewer, { value: config, rootName: `@iotv/config (${appCode})`, editable: false, displaySize: false, displayComma: false, quotesOnKeys: false, objectSortKeys: false, enableClipboard: true, displayDataTypes: false, defaultInspectDepth: 2, groupArraysAfterLength: undefined, collapseStringsAfterLength: 200, sx: { fontSize: '1.15em' } }) }) })] }));
};
